import React from 'react';
import './Position.css';

import { Button } from '../../components';

import { FaBriefcase, FaDollarSign } from 'react-icons/fa';

import { Link } from 'react-router-dom';
import { renderIcon } from '../../utils';
import { FaLocationDot } from 'react-icons/fa6';



const Position = ({ position }) => {

  return (

    /* Container for each job position item */
    <div className='position-item' key={position.id}>

      <div className='icon'>{renderIcon(position.title)}</div>

      {/* Link to the individual job position page */}
      <Link
        to={{
          pathname: '/Careers/' + position.title,  // Navigate to specific job position page
        }}
        state={position}  // Pass position details to the linked page
        className='main-heading' >
        <h3>{position.title}</h3> {/* Job title */}
      </Link>

      <p>{position.content}</p>

      <div className='details'>
        <h5><FaLocationDot className='icon' /><span>{position.details.location}</span></h5> {/* Job Location */}
        <h5><FaBriefcase className='icon' /><span>{position.details.timing}</span></h5> {/* Job Timing */}
        <h5><FaDollarSign className='icon' /><span>{position.details.salary}</span></h5> {/* Job Salary  */}
      </div>

      <Button link={'Career-Form'} title={'Apply Now'} /> {/* 'Apply Now' button which redirects to the career form */}

    </div>

  );
};

export default Position;